import { useState } from "react";
import { useNavigate, Link } from "react-router";
import { EyeOff, Eye } from "lucide-react";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import Button from "../ui/button/Button";
import Alert from "../ui/alert/Alert";
import { useAuth } from "../../context/AuthContext";
import { useConfig } from "../../context/ConfigContext";

export default function SignInForm() {
  const { login } = useAuth();
  const { nomeApp, faviconPath } = useConfig();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      await login(email, senha);
      navigate("/dashboard");
    } catch (err: any) {
      setErro(err?.data?.erro || "Não foi possível entrar.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 sm:mb-8 text-center sm:text-left">
            <div className="flex flex-col items-center sm:items-start gap-4 mb-5">
              {faviconPath ? (
                <img
                  src={faviconPath}
                  alt="Logo"
                  className="h-16 w-16 object-contain rounded-2xl shadow-md border border-gray-100 dark:border-gray-800"
                />
              ) : (
                <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-brand-600 text-white font-bold text-3xl shadow-md">
                  {nomeApp.slice(0, 1)}
                </div>
              )}
              <div>
                <h1 className="font-bold text-gray-850 text-title-sm dark:text-white/95 sm:text-title-md tracking-tight">
                  {nomeApp}
                </h1>
                <p className="mt-1.5 text-sm font-medium text-gray-500 dark:text-gray-400">
                  Entre com sua conta para acessar o painel.
                </p>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="space-y-6">
              <div>
                <Label htmlFor="login-email">
                  Email <span className="text-error-500">*</span>
                </Label>
                <Input
                  id="login-email"
                  type="email"
                  placeholder="seuemail@exemplo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <Label htmlFor="login-senha">
                  Senha <span className="text-error-500">*</span>
                </Label>
                <div className="relative">
                  <Input
                    id="login-senha"
                    type={showPassword ? "text" : "password"}
                    placeholder="Digite sua senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
                    className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
                  >
                    {showPassword ? (
                      <Eye className="fill-gray-500 dark:fill-gray-400 size-5" />
                    ) : (
                      <EyeOff className="fill-gray-500 dark:fill-gray-400 size-5" />
                    )}
                  </button>
                </div>
                <div className="mt-2 text-right">
                  <Link to="/esqueci-senha" className="text-sm text-brand-500 hover:underline dark:text-brand-400">
                    Esqueci minha senha
                  </Link>
                </div>
              </div>
              {erro && <Alert variant="error" title="Erro" message={erro} />}
              <div>
                <Button className="w-full" size="sm" disabled={enviando}>
                  {enviando ? "Entrando..." : "Entrar"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
